export enum comparisonType {
  BY_YEARS = 'BY_YEARS',
  BY_INDUSTRY = 'BY_INDUSTRY',
}
